import { useRequiredErpCompany } from "@/common/hooks/use-erp-company";

import { Strategy } from "../marketplace.flow";

class FullStrategy implements Strategy {
  public canInteract() {
    return true;
  }

  public showCallToAction() {
    return false;
  }

  public getcompanyGetter() {
    return useRequiredErpCompany;
  }
}

export { FullStrategy };
